import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-horizontal" }
const _hoisted_2 = { class: "table-responsive p-0" }
const _hoisted_3 = { class: "table table-bordered text-nowrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Index"),
    /*#__PURE__*/_createElementVNode("th", null, "Star goal"),
    /*#__PURE__*/_createElementVNode("th", null, "Credit reward"),
    /*#__PURE__*/_createElementVNode("th", null, "Heart reward"),
    /*#__PURE__*/_createElementVNode("th", null, "Booster type"),
    /*#__PURE__*/_createElementVNode("th", null, "Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_5 = { class: "card-footer" }
const _hoisted_6 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_form_row = _resolveComponent("app-form-row")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_error = _resolveComponent("app-error")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Add Map"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", _hoisted_1, [
        _createVNode(_component_app_form_row, { label: "ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              type: "number",
              modelValue: _ctx.model.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.id) = $event)),
              modelModifiers: { number: true },
              validations: _ctx.v$.id
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Name" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.model.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.name) = $event)),
              validations: _ctx.v$.name
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "IAP Item" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_select, {
              options: _ctx.iapOptions,
              modelValue: _ctx.model.selectedIap,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.selectedIap) = $event)),
              modelModifiers: { number: true }
            }, null, 8, ["options", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Package ID" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              modelValue: _ctx.model.packageId,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.packageId) = $event)),
              validations: _ctx.v$.packageId
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createVNode(_component_app_form_row, { label: "Price" }, {
          default: _withCtx(() => [
            _createVNode(_component_app_input, {
              type: "number",
              modelValue: _ctx.model.price,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.price) = $event)),
              modelModifiers: { number: true },
              validations: _ctx.v$.price
            }, null, 8, ["modelValue", "validations"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("table", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.chestRewardList, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "data-row",
                  key: item.index
                }, [
                  _createElementVNode("td", null, _toDisplayString(item.index), 1),
                  _createElementVNode("td", null, _toDisplayString(item.requiredStar), 1),
                  _createElementVNode("td", null, _toDisplayString(item.creditReward), 1),
                  _createElementVNode("td", null, _toDisplayString(item.heartReward), 1),
                  _createElementVNode("td", null, _toDisplayString(item.boosterTypeRewardName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.boosterQuantityReward), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_app_button, {
                      theme: "danger",
                      icon: "fa-trash-alt",
                      size: "xs",
                      onClick: _withModifiers(($event: any) => (_ctx.actions.removeChestReward(item.index)), ["prevent"])
                    }, null, 8, ["onClick"])
                  ])
                ]))
              }), 128)),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _createVNode(_component_app_input, {
                    modelValue: _ctx.model.chestIndex,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.chestIndex) = $event)),
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_app_input, {
                    modelValue: _ctx.model.chestRequiredStar,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.chestRequiredStar) = $event)),
                    validations: _ctx.v$.chestRequiredStar
                  }, null, 8, ["modelValue", "validations"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_app_input, {
                    modelValue: _ctx.model.chestCreditReward,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.chestCreditReward) = $event)),
                    validations: _ctx.v$.chestCreditReward
                  }, null, 8, ["modelValue", "validations"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_app_input, {
                    modelValue: _ctx.model.chestHeartReward,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.chestHeartReward) = $event)),
                    validations: _ctx.v$.chestHeartReward
                  }, null, 8, ["modelValue", "validations"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_app_select, {
                    options: _ctx.SelectableBooster,
                    modelValue: _ctx.model.chestBoosterTypeReward,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.chestBoosterTypeReward) = $event)),
                    modelModifiers: { number: true },
                    validations: _ctx.v$.chestBoosterTypeReward,
                    style: {"min-width":"170px"}
                  }, null, 8, ["options", "modelValue", "validations"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_app_input, {
                    modelValue: _ctx.model.chestBoosterQuantityReward,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.chestBoosterQuantityReward) = $event)),
                    validations: _ctx.v$.chestBoosterQuantityReward
                  }, null, 8, ["modelValue", "validations"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_app_button, {
                    name: "Add chest",
                    theme: "success",
                    size: "xs",
                    onClick: _withModifiers(_ctx.actions.addChestReward, ["prevent"])
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            _createVNode(_component_app_error, {
              validations: _ctx.v$.chestRewardList
            }, null, 8, ["validations"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_app_button, {
              name: "Create",
              theme: "info",
              icon: "fa-save",
              onClick: _withModifiers(_ctx.actions.create, ["prevent"])
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}